module.exports = __webpack_public_path__ + "static/media/theater-masks.027d61a4.svg";